import React from "react";

import { IgCardSelect } from "@intelligems/ig-theme/IgCardSelect";
import {
  ChannelType,
  DeviceType,
  VisitorType,
} from "@intelligems/ig-types/schemas/analytics/base";
import { visitorTypeList } from "@src/components/AudienceFilters/utils";

interface VisitorTypeFilterProps {
  onStringFilterChange: (
    newValue: DeviceType | VisitorType | ChannelType,
    filterKey: "deviceType" | "channelType" | "visitorType"
  ) => void;
  visitorType?: VisitorType | null;
}

export const VisitorTypeFilter = ({
  visitorType,
  onStringFilterChange,
}: VisitorTypeFilterProps) => {
  return (
    <IgCardSelect
      options={visitorTypeList.map(({ key, label, description }) => ({
        title: label,
        description,
        value: key ?? "any",
      }))}
      value={visitorType || "any"}
      onChange={(value) => {
        onStringFilterChange(value, "visitorType");
      }}
    />
  );
};
